import { render } from "./Menu.vue?vue&type=template&id=5d07b375&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=5d07b375&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5d07b375"

export default script